import styled from 'styled-components'

export const TestimonyContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: white;
  gap: 2rem;
  flex-wrap: wrap;
  padding-block: 5rem;
`
export const VideoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  gap: 2rem;
  flex-wrap: wrap;

  a {
    display: inline-block;
    transition: transform 0.3s ease;

    &:hover {
      cursor: pointer;
      transform: scale(1.05);
    }
  }

  img {
    width: 400px;
    height: 220px;
  }

  @media (max-width: 720px) {
    img {
      width: 300px;
      height: 160px;
    }
  }
`

export const Title = styled.span`
  font-family: Poppins;
  font-size: 3.5rem;
  font-weight: bold;
  color: #fa8c16;

  @media (max-width: 720px) {
    font-size: 2rem;
  }
`
